var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("global-header", {
        staticClass: "layout-header",
        attrs: {
          mode: _vm.layoutMode,
          menus: _vm.menus,
          theme: _vm.navTheme,
          collapsed: _vm.collapsed,
          device: _vm.device,
        },
        on: { toggle: _vm.toggle },
      }),
      _c(
        "a-layout",
        {
          staticClass: "layout",
          class: [_vm.device],
          style: { paddingTop: "59px", height: "100%" },
        },
        [
          _vm.layoutMode === "sidemenu" && _vm.isShowMenus
            ? [
                _c("side-menu", {
                  attrs: {
                    mode: "inline",
                    menus: _vm.menus,
                    theme: _vm.navTheme,
                    collapsed: _vm.collapsed,
                    collapsible: true,
                  },
                  on: { menuSelect: _vm.myMenuSelect, toggle: _vm.toggle },
                }),
              ]
            : [
                _vm.device === "mobile"
                  ? _c(
                      "a-drawer",
                      {
                        attrs: {
                          wrapClassName: "drawer-sider " + _vm.navTheme,
                          placement: "left",
                          closable: false,
                          visible: _vm.collapsed,
                          width: "200px",
                        },
                        on: { close: () => (this.collapsed = false) },
                      },
                      [
                        _c("side-menu", {
                          attrs: {
                            mode: "inline",
                            menus: _vm.menus,
                            theme: _vm.navTheme,
                            collapsed: _vm.collapsed,
                            collapsible: true,
                          },
                          on: {
                            menuSelect: _vm.menuSelect,
                            toggle: _vm.toggle,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
          _c(
            "a-layout",
            {
              class: [
                "outer-layer-roll",
                _vm.layoutMode,
                `content-width-${_vm.contentWidth}`,
              ],
              style: {
                paddingLeft:
                  _vm.fixSiderbar && _vm.isDesktop()
                    ? `${_vm.sidebarOpened ? 200 : 60}px`
                    : "0",
                position: "relative",
              },
            },
            [
              _c(
                "a-layout-content",
                { style: { height: "100%" } },
                [_vm._t("default")],
                2
              ),
              _c(
                "a-layout-footer",
                { staticStyle: { padding: "0px" } },
                [_c("global-footer")],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }